const COLORS = {
  PRIMARY: '#C3645E',
  SECONDARY: '#A75550',
  DARK: '#444',
  WHITE: '#FFF',
} as const;

const STORAGE_KEYS = {
  user: "sos_user",
  auth_token: "sos-api-auth-token",
  training: "sos_training",
  loggin: "sos_logged",
  lang: "sos_language",
  moleculesStats: "sos_molecules_stats",
  symptomsStats: "sos_symptoms_stats",
} as const;

const ALPHABET = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];

const CONTRIBUTORS = [
  {
    name: "Dr Vincent Sibaud",
    picture:
      "https://app-fr.one-smile.care/images/forwards/sections/forward12_section1025_photo0.jpeg",
    fonction:
      "Oncodermatologue, institut Universitaire du cancer , Toulouse Oncopole, France – Centre de lutte contre le cancer",
    spec: [
      "Expert international des toxicités dermatologiques des traitements anticancéreux - auteur de nombreux ouvrages et publications dans ce domaine",
      'Chairman de l’European Task Force "dermatology for cancer patients"',
    ],
    subtext:
      "<i><p>L'application <strong>S.O.S.</strong>, d&eacute;velopp&eacute;e par les Laboratoires dermatologiques Av&egrave;ne, a &eacute;t&eacute; con&ccedil;ue pour accompagner et former les professionnels de sant&eacute; dans la prise en charge et le conseil des patients souffrant de sympt&ocirc;mes dermatologiques li&eacute;s aux chimioth&eacute;rapies, th&eacute;rapies cibl&eacute;es, immunoth&eacute;rapie ou &agrave; la radioth&eacute;rapie.</p>\r\n<p>Avec cette application, vous pourrez :</p>\r\n<ul>\r\n<li>Apprendre &agrave; reconna&icirc;tre les principaux sympt&ocirc;mes et identifier les mol&eacute;cules inductrices</li>\r\n<li>Am&eacute;liorer la prise en charge de vos patients et leur qualit&eacute; de vie</li>\r\n<li>Tester vos connaissances gr&acirc;ce &agrave; de nombreux quiz et cas pratiques</li>\r\n<li>Etre inform&eacute; r&eacute;guli&egrave;rement sur les &eacute;volutions des nouveaux traitements et leurs effets ind&eacute;sirables</li>\r\n</ul></i>",
  },
  // {
  //   name: "Pr Caroline ROBERT",
  //   picture:
  //     "https://app-fr.one-smile.care/images/forwards/sections/forward12_section1024_photo0.jpeg",
  //   fonction: "Chef de service du département d’Oncodermatologie",
  //   spec: [
  //     "Oncodermatologue, Institut Gustave Roussy, Grand Paris, France – Centre de lutte contre le cancer",
  //     "Experte internationale du mélanome et des toxicités dermatologiques des traitements anticancéreux - auteure de nombreux ouvrages et publications dans ces domaines",
  //   ],
  // },
];

const MOLECULE_SECTION = {
  CHIMIO: 'chim',
  THERAPY: 'ther',
  IMMUNO: 'immu',
  HORMONO: 'horm'
} as const

// Correspondance section UI -> valeur `type` renvoyée par la BDD
const MOLECULE_TYPE_BY_SECTION = {
  [MOLECULE_SECTION.CHIMIO]: '1',
  [MOLECULE_SECTION.THERAPY]: '2',
  [MOLECULE_SECTION.IMMUNO]: '3',
  [MOLECULE_SECTION.HORMONO]: '4',
} as const

export {
  COLORS,
  CONTRIBUTORS,
  ALPHABET,
  STORAGE_KEYS,
  MOLECULE_SECTION,
  MOLECULE_TYPE_BY_SECTION,
}